export default __webpack_public_path__ + "static/media/nuketown.13850ae3.jpg";